import { createSlice } from "@reduxjs/toolkit";

const productSlice = createSlice({
  name: "product",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {
    getProductDataRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getProductDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getProductDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getProductDataRequest,
  getProductDataSuccess,
  getProductDataFailure,

} = productSlice.actions;

export default productSlice.reducer;
